FreeBoardLimitInfo = require('common/components/create-board/free-board-limit-info').default
{ ldclient } = require 'common/lib/ldclient'
PopOver = require 'views/lib/pop-over'
React = require 'react'
t = require('views/internal/recup-with-helpers')('board_list_item_add')
Util = require 'lib/util'
ClientConfig = require 'debug/client-config'
localizeCount = require 'lib/localize-count'
{ usesEnglish } = require 'common/lib/util/locale'
{ boardLimitsGracePeriodEndDate } = require 'common/data/rollout-dates'

isDesktop = ClientConfig.get('appId') == 'desktop'

module.exports = class extends React.Component
  displayName: 'BoardListItemAddComponent'
  constructor: (props) ->
    super props

    @state = {
      boardLimitsFlag: ldclient.variation('bc.board_limits', false)
      boardLimitsGracePeriodFlag: ldclient.variation('bc.board_limits_grace_period', false)
    }

    @questionRef = React.createRef()
    @textRef = React.createRef()

    @onLdUpdate = @onLdUpdate.bind(@)
    @onLdUpdateGracePeriod = @onLdUpdateGracePeriod.bind(@)
    @hidePopOver = @hidePopOver.bind(@)
    @handleOnMouseEnter = @handleOnMouseEnter.bind(@)
    @handleOnMouseLeave = @handleOnMouseLeave.bind(@)

  onLdUpdate: (newVal) ->
    @setState({ boardLimitsFlag: newVal })

  onLdUpdateGracePeriod: (newVal) ->
    @setState({ boardLimitsGracePeriodFlag: newVal })

  componentDidMount: ->
    ldclient.on 'change:bc.board_limits', @onLdUpdate
    ldclient.on 'change:bc.board_limits_grace_period', @onLdUpdateGracePeriod

  componentWillUnmount: ->
    ldclient.off 'change:bc.board_limits', @onLdUpdate
    ldclient.off 'change:bc.board_limits_grace_period', @onLdUpdateGracePeriod

  handleOnMouseEnter: (currentRef) => (e) =>
    { org } = @props
    { boardLimitsGracePeriodFlag } = @state
    @setState({ isActive: true })
    limit = org.getFreeBoardLimit()

    if currentRef
      @setState({ currentRef })
    else
      currentRef = @state.currentRef

    textComponent = React.createElement FreeBoardLimitInfo,
      key: 1
      isLimitOverridden: org.isFreeBoardLimitOverridden(),
      isAtOrOverLimit: org.isAtOrOverFreeBoardLimit(),
      isDesktop: isDesktop,
      isGracePeriod: boardLimitsGracePeriodFlag,
      openBoardCount: limit.count,
      orgName: org.get('displayName'),
      upgradeUrl: org.getBillingUrl(),
      gracePeriodEndDate: boardLimitsGracePeriodEndDate,
      onMouseEnter: @handleOnMouseEnter(currentRef),
      onMouseLeave: @handleOnMouseLeave,
      shouldShowFeedbackLink: boardLimitsGracePeriodFlag && usesEnglish(),

    PopOver.show
      elem: currentRef.current
      maxWidth: '242'
      hideHeader: true
      reactElement: textComponent

  handleOnMouseLeave: ->
    @setState({
      isActive: false
    })
    setTimeout((@hidePopOver), 500)

  hidePopOver: ->
    if !@state.isActive
      PopOver.hide()

  render: t.renderable ->
    { newBoard, preloadData, org } = @props
    { boardLimitsFlag } = @state

    if !org?.isPremium()
      preloadData()
      boardsRemaining = org?.getFreeBoardsRemaining()
      showBoardsRemaining = boardLimitsFlag &&
        !isDesktop &&
        org?.isCloseToFreeBoardLimit()
      boardsOver = org?.getFreeBoardsOver() || 0
      showBoardsOver = boardsOver > 0

    t.li '.boards-page-board-section-list-item', =>
      t.div '.board-tile.mod-add', { onMouseOver: preloadData, onClick: newBoard }, =>
        t.p '.bold', ->
          t.format('create-new-board-ellipsis')
        if showBoardsRemaining
          t.p '.remaining', =>
            t.format('count-remaining', { boardsRemaining })
            if showBoardsOver
              t.span '.over-limit-text', =>
                t.text ' | '
                t.span '.boards-over-limit', {
                  onMouseEnter: @handleOnMouseEnter(@textRef),
                  onMouseLeave: @handleOnMouseLeave,
                  ref: @textRef
                }, ->
                  t.a ->
                    t.text localizeCount('boards-over', boardsOver)
          t.div '.question-icon', {
            onMouseEnter: @handleOnMouseEnter(@questionRef),
            onMouseLeave: @handleOnMouseLeave,
            ref: @questionRef
          }, =>
            t.icon 'help'



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-item-add-component.coffee